import { Grid } from "@mui/material";
import SectionStructureBlood from '../../components/Section/SectionStructureBlood';
import LabfinderText from "./LabfinderText";
import LabfinderSubText from "./LabfinderSubText";
import SynlabMapLibre from "./SynlabMapLibre";


export default function LabfinderSection() {

  

return (

    <SectionStructureBlood

        sectiontext = {<LabfinderText />}
        sectionsubtext = {<LabfinderSubText />}
       
        
        sectioncards = {
        
            <Grid container spacing={2}>
               
                <Grid size={{xs:12}} sx={{display:'flex',justifyContent:'center'}}> <SynlabMapLibre />    </Grid> 

            </Grid>  
        }
    />


    )
}
